// @flow
import * as React from 'react';
import { SEARCH_RADIUSES } from 'utils/constants';
import { getter, compose } from 'utils/functional';
import Select from 'components/Select';

const radiusOptions = SEARCH_RADIUSES[USER_LOCALE].map(({ id, name }) => ({
  value: id,
  label: name
}));

const SearchRadiusSelector = ({
  radius,
  setSearchRadius
}: {
  radius: string,
  setSearchRadius: string => void
}) => (
  <Select
    label={getText('Search radius')}
    name="radius"
    value={radius}
    options={radiusOptions}
    onChange={compose(
      setSearchRadius,
      getter('value')
    )}
    data-qa-id="search-radius-selector"
  />
);

export default SearchRadiusSelector;
